import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { MovimientoBancarioReadingDtoProps } from "api/DTOs/MovimientoBancarioReadingDto"
import { putFlujoTesoreriaForzarConciliacion } from "api/FlujoTesoreria.service"
import { forzarConciliacion } from "api/MovimientoBancario.service"
import Modal from "common/components/Modal/Modal"
import { Button } from "primereact/button"
import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"
import { SelectedDocumentsProps } from "../layout/ColumnRight"

interface ModalForzarConciliacionProps {
  showModalMarcarConciliado: boolean
  setShowModalMarcarConciliado: Dispatch<SetStateAction<boolean>>
  data: MovimientoBancarioReadingDtoProps[] | undefined
  dataMovContables: SelectedDocumentsProps[] | undefined
  handleUnselectRows: () => void
  fetchTableData: () => void
}

const ModalForzarConciliacion: React.FC<ModalForzarConciliacionProps> = ({
  showModalMarcarConciliado,
  setShowModalMarcarConciliado,
  data,
  dataMovContables,
  handleUnselectRows,
  fetchTableData,
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      visible={showModalMarcarConciliado}
      closable={false}
      className=' !tw-w-fit tw-rounded-md !tw-p-0 !tw-px-10 !tw-pb-6 !tw-pt-9'
      contentClassName='!tw-p-0'
      onHide=''
      showHeader={false}
    >
      <div className='tw-flex tw-flex-col tw-justify-center '>
        <div className='tw-mb-4 tw-flex tw-w-full tw-justify-center'>
          <div className='tw-flex tw-h-24 tw-w-24 tw-items-center tw-justify-center tw-rounded-full tw-bg-background'>
            <div className='tw-flex tw-h-16 tw-w-16 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-border tw-bg-white'>
              <FontAwesomeIcon
                icon={["fal", "question"]}
                className='tw-h-8 tw-text-text-hyperlink'
              />
            </div>
          </div>
        </div>
        <div className='tw-mb-10 tw-flex tw-w-full tw-flex-col tw-items-center'>
          <p className='tw-mb-3 tw-text-xl tw-font-medium'>
            {t("bancos.conciliacion.modal.marcarConciliado.title")}
          </p>
          <p className='tw-mb-0 tw-w-80 tw-text-wrap tw-text-center tw-text-lg'>
            {t("bancos.conciliacion.modal.marcarConciliado.text")}
          </p>
        </div>
        <div className='tw-mb-1 tw-flex tw-w-full tw-flex-row'>
          <Button
            onClick={() =>
              setShowModalMarcarConciliado(!showModalMarcarConciliado)
            }
            className='!tw-mr-1.5 !tw-flex !tw-h-12 !tw-w-44 !tw-items-center !tw-justify-center !tw-border-transparent !tw-bg-transparent !tw-text-text hover:!tw-shadow'
          >
            {t("bancos.conciliacion.modal.marcarConciliado.cancel")}
          </Button>
          <Button
            className='!tw-ml-1.5 !tw-flex !tw-h-12 !tw-w-44 !tw-items-center !tw-justify-center !tw-rounded !tw-border-transparent !tw-bg-primary !tw-text-white hover:!tw-bg-primary-over hover:!tw-shadow'
            onClick={async () => {
              if (data?.length) {
                const arrayConciliar: string[] = data
                  ? data.reduce<string[]>((acc, row) => {
                      if (row?.idExterno) acc.push(row.idExterno)
                      return acc
                    }, [])
                  : []
                await forzarConciliacion({
                  movimientoBancarioIdsExternos: arrayConciliar ?? [],
                })
              }
              if (dataMovContables?.length) {
                const arrayConciliarContables: string[] =
                  dataMovContables
                    .filter(
                      (row) => row?.tabKey === "flujoTesoreriaIds" && row?.id
                    )
                    .map((row) => String(row.id)) || []
                if (!arrayConciliarContables.length) return
                await putFlujoTesoreriaForzarConciliacion({
                  flujoTesoreriaIds: arrayConciliarContables ?? [],
                })
              }
              setShowModalMarcarConciliado(!showModalMarcarConciliado)
              handleUnselectRows()
              fetchTableData()
            }}
          >
            {t("bancos.conciliacion.modal.marcarConciliado.continuar")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default ModalForzarConciliacion
